"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SponsorTextTopRow = exports.SponsorTextBottomRow = exports.MenuIconRoot = exports.InnerText = exports.FloatingBannerRoot = exports.ClearIcon = exports.BannerIcon = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _constants = require("./constants");
const MenuIconRoot = exports.MenuIconRoot = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme,
  animate
}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  svg: {
    fill: theme.palette.offer.main,
    width: '26px',
    height: '26px',
    animation: animate ? `hithere ${_constants.GIFT_ANIMATION_DURATION_SECONDS}s ease ${_constants.GIFT_ANIMATION_REPEAT_TIMES}` : 'none',
    '@keyframes hithere': {
      '30%': {
        transform: 'scale(1.2)'
      },
      '40%, 60%': {
        transform: 'rotate(-20deg) scale(1.2)'
      },
      '50%': {
        transform: 'rotate(20deg) scale(1.2)'
      },
      '70%': {
        transform: 'rotate(0deg) scale(1.2)'
      },
      '100%': {
        transform: 'scale(1)'
      }
    }
  }
}));
const FloatingBannerRoot = exports.FloatingBannerRoot = (0, _mui.styled)('aside')(({
  theme
}) => ({
  display: 'flex',
  gap: theme.spacing(2),
  padding: theme.spacing(2),
  borderRadius: theme.spacing(2),
  background: theme.palette.offer.light,
  cursor: 'pointer',
  width: 'calc(100% - 30px)',
  left: '50%',
  position: 'fixed',
  transform: 'translateX(-50%)',
  zIndex: 11,
  top: `calc(${_presentationUtils.CSS_MOBILE_HEIGHT} + ${theme.spacing(3)})`,
  alignItems: 'center',
  boxSizing: 'border-box',
  [theme.breakpoints.up('sm')]: {
    top: `calc(${_presentationUtils.CSS_DESKTOP_HEIGHT} + ${theme.spacing(3)})`,
    width: 330,
    right: theme.spacing(3),
    left: 'auto',
    transform: 'none'
  }
}));
const InnerText = exports.InnerText = (0, _mui.styled)('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'start'
});
const BannerIcon = exports.BannerIcon = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  width: theme.spacing(8),
  height: theme.spacing(8),
  padding: 8,
  alignItems: 'center',
  gap: theme.spacing(2),
  borderRadius: theme.spacing(4),
  background: theme.palette.default.contrastText,
  boxSizing: 'border-box',
  svg: {
    fill: theme.palette.offer.main,
    width: 24,
    height: 24
  }
}));
const SponsorTextTopRow = exports.SponsorTextTopRow = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  fontWeight: theme.typography.fontWeightBold,
  textTransform: 'uppercase',
  overflow: 'ellipsis'
}));
const SponsorTextBottomRow = exports.SponsorTextBottomRow = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  fontWeight: theme.typography.fontWeightBold,
  textTransform: 'capitalize',
  overflow: 'ellipsis'
}));
const ClearIcon = exports.ClearIcon = (0, _mui.styled)('div')({
  marginLeft: 'auto',
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  svg: {
    width: 18,
    height: 18
  }
});
